import { isNil } from '@alk/core';
/**
 * Utils function to build the sleeve class to use given the value of the cell.
 */
export function getSleeveClass(value) {
    return isNil(value) ? undefined : `ag-sleeve-${value.replace(/ +/g, '-').toLowerCase()}`;
}
